const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

const request = async (endpoint, options = {}) => {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        ...options,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...(options.headers || {}),
        },
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
        const message = data.message || getDefaultErrorMessage(response.status);
        throw new Error(message);
    }

    return data;
};

const getDefaultErrorMessage = (status) => {
    if (status === 422) {
        return "Invalid receipt claim details.";
    }

    if (status === 429) {
        return "Too many attempts. Please try again later.";
    }

    if (status >= 500) {
        return "Server error. Please try again later.";
    }

    return "Something went wrong.";
};

export const rewardApi = {
    claimReceipt: async ({ invoice_no, phone, target }) => {
        return request("/api/v1/receipt-claims", {
            method: "POST",
            body: JSON.stringify({
                invoice_no,
                phone,
                target,
            }),
        });
    },
};
